import React from 'react';
import { toast } from 'react-hot-toast';
import SellerApplicationComponent from './SellerApplicationComponent';

// Mock de hooks - reemplazar con los reales en tu proyecto
const useNavigate = () => {
    return (path: string, options?: any) => {
        console.log('Navigate to:', path, options);
    };
};

const useAuth = () => {
    return {
        user: {
            id: 1,
            user_type: 'customer', // Cambiar a 'seller' para probar la redirección
            first_name: 'Juan',
            last_name: 'Pérez'
        }
    };
};



const SellerApplicationPage: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    // Verificar si el usuario ya es vendedor
    React.useEffect(() => {
        if (user?.user_type === 'seller') {
            toast('Ya eres un vendedor. Te redirigimos a tu panel.');
            navigate('/seller/dashboard');
        }
    }, [user, navigate]);

    const handleSuccess = () => {
        // Redirigir al home con mensaje de éxito
        navigate('/');
        toast.success('¡Solicitud enviada exitosamente! Te contactaremos pronto.');
    };

    const handleCancel = () => {
        navigate('/');
    };

    // Si ya es vendedor, no mostrar nada mientras redirige
    if (user?.user_type === 'seller') {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center" >
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Redirigiendo a tu panel de vendedor...</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            <SellerApplicationComponent
                onSuccess={handleSuccess}
                onCancel={handleCancel}
            />
        </div>
    );
};

export default SellerApplicationPage;